var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm5.304 11.106L15.371 11h1.349c.389 0 .745.228.908.58l1.08 2.339a1 1 0 1 0 1.815-.838l-1.08-2.34A3.01 3.01 0 0 0 16.719 9s-3.006-.01-3.068 0a3.026 3.026 0 0 0-1.98 1.023c-.044.05-1.441 2.474-1.441 2.474-.178.311-.51.503-.868.503H6.998a1 1 0 1 0 0 2h2.364a3.007 3.007 0 0 0 2.603-1.508l.222-.387 1.664 3.609-1.728 1.411a2.992 2.992 0 0 0-1.102 2.324V23a1 1 0 1 0 2 0v-2.551c0-.302.134-.585.367-.775l2.315-1.89c1.191-.79 1.661-2.31 1.099-3.678ZM21 19h-2.339a.995.995 0 0 1-.581-.186 1 1 0 0 0-1.16 1.629 2.984 2.984 0 0 0 1.74.557h2.339a1 1 0 1 0 0-2ZM15 2c1.654 0 3 1.346 3 3v1a1 1 0 1 0 2 0V5c0-2.757-2.243-5-5-5H6.002c-2.756 0-5 2.242-5 4.999L1 23a1 1 0 0 0 2 0l.002-18.001a3.003 3.003 0 0 1 3-2.999H15Z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitAlt);
export default __webpack_public_path__ + "static/media/exit-alt.c996b63ed6355732616f07c8c1ffee4a.svg";
export { ForwardRef as ReactComponent };